/*
 * DeleteProjectModal Messages
 *
 * This contains all the text for the DeleteProjectModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.deleteModal';

export default defineMessages({
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  deleteItem: {
    id: `${scope}.deleteItem`,
    defaultMessage: 'Delete',
  },
  modalConfirmationTitle: {
    id: `${scope}.modalConfirmationTitle`,
    defaultMessage: 'Delete this project?',
  },
  modalConfirmationDescription: {
    id: `${scope}.modalConfirmationDescription`,
    defaultMessage: 'You will not be able to recover this project once deleted. Are you sure you want to continue?',
  },
});
